/**
 * @generated SignedSource<<083791ee8fe8ac629678816f5ad84129>>
 * @relayHash 18a79873a0d8adb8b564459d1e3933ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e912661cb90a2ca17e80283a3722471456baf4b4679e680954281ed13e4261ef

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { InlineCreateAdditionalFieldsEntrypointQuery } from './InlineCreateAdditionalFieldsEntrypointQuery.graphql';

const node: PreloadableConcreteRequest<InlineCreateAdditionalFieldsEntrypointQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e912661cb90a2ca17e80283a3722471456baf4b4679e680954281ed13e4261ef",
    "metadata": {},
    "name": "InlineCreateAdditionalFieldsEntrypointQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
